module.exports = __webpack_public_path__ + "assets/img/company3 (2).c2af9893.jpg";